import React from "react";
import "./ActionsTable.scss";
import FieldValue from "./FieldValue";

import { changeLogActionTypeName, changeLogActionNames } from "../../constants";

import StrDiff from "./StrDiff";

function action2name(action) {
  return changeLogActionNames[action] || action;
}

function actionType2name(action_type) {
  return changeLogActionTypeName[action_type] || action_type;
}

function field2name(fieldName) {
  const map = {
    title: "Заголовок",
    desc: "Опиание",
    url: "URL",
    published: "Статус",
    type: "Область показов",
    active_until: "TTL",
    should_reset_stat: "Перезакидывание",
    use_campaign_cpc: "Использовать CPC кампании",
    category: "Категория",
    cid: "Кампания",
    payout_status: "Статус оплаты",
    grade_status: "Статус оценки"
  };

  return map[fieldName] || fieldName;
}

const ActionsTable = ({ actions }) => {
  return (
    <table className="actions-table">
      <thead>
        <tr>
          <th>Действие</th>
          <th>Тип действия</th>
          <th>Системное</th>
          <th>Поле</th>
          <th>До изменения</th>
          <th>После изменения</th>
        </tr>
      </thead>
      <tbody>
        {actions.map(action => (
          <tr>
            <td>{action2name(action.action)}</td>
            <td>{actionType2name(action.action_type)}</td>
            <td>{action.is_system ? "Да" : "Нет"}</td>
            <td>{field2name(action.field_name)}</td>
            <td>
              <FieldValue action={action} isNew={false} />
            </td>
            <td>
              <FieldValue action={action} isNew={true} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ActionsTable;
